import React, { useEffect } from "react"
import { default as NextHead } from "next/head"
import { initGoogleTagManager } from "@/lib/google-tag-manager"
import { usePathData, useAppContext } from "@/lib/contexts/appContext"

export default function Head() {
  const { head } = usePathData()
  const { meta } = useAppContext()

  useEffect(() => {
    const { gtmContainerId, cookieScriptUrl } = meta
    if (gtmContainerId) {
      initGoogleTagManager(gtmContainerId, cookieScriptUrl)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <NextHead>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      {head &&
        head.map((meta, index) => {
          const Tag = meta.tag
          const attrs = meta.attrs

          if (meta.tag === "title") {
            return <Tag key={index}>{attrs.innerText}</Tag>
          }

          if (meta.tag === "script" && attrs?.src) {
            return <Tag key={index} type="text/javascript" src={attrs.src} />
          }

          if (meta.tag === "script" && attrs?.type === "application/ld+json") {
            return (
              <script
                key={index}
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                  __html: JSON.stringify(attrs.content)
                }}
              />
            )
          }

          if (meta.tag === "meta" && attrs.name === "robots") {
            const content =
              meta?.env === "prod"
                ? Object.values(attrs.content).join(", ")
                : "noindex, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
            return <Tag key={index} name={attrs.name} content={content} />
          }

          if (
            typeof attrs.content === "object" &&
            attrs?.property === "og:images"
          ) {
            const { ...content } = attrs
            const [url, props] = Object.entries(content?.content)[0]
            return (
              <React.Fragment key={index}>
                <meta property="og:image" content={url} />
                <meta property="og:image:width" content={props.width} />
                <meta property="og:image:height" content={props.height} />
                <meta property="og:image:secure_url" content={props.url} />
              </React.Fragment>
            )
          }

          return <Tag key={index} {...attrs} />
        })}
    </NextHead>
  )
}
